// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"4a594861","64":"9f984aff","501":"e1338bb8","508":"55df4476","659":"03297cf8","923":"c01871e1","970":"94c52c09"}[chunkId] + ".chunk.css";
};